import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

import MemberOne from "../../assets/images/webp/overviewPage/memberOne.webp";
import MemberTwo from "../../assets/images/webp/overviewPage/memberTwo.webp";

import './animate.scss'

const boxVariant = {
    visible: { opacity: 1, scale: 1, transition: { type: "spring", stiffness: 120, duration: 0.5 } },
    hidden: { opacity: 0, scale: 0 }
};

const Box = ({ num }) => {

    const control = useAnimation();
    const [ref, inView] = useInView();

    useEffect(() => {
        if (inView) {
            control.start("visible");
        } else {
            control.start("hidden");
        }
    }, [control, inView]);

    return (
        <>
            <div className="box-container">
                <motion.div
                    className="box"
                    ref={ref}
                    variants={boxVariant}
                    initial="hidden"
                    animate={control}
                    whileTap={{
                        scale: 0.8,
                        rotate: -90,
                        borderRadius: "100%"
                    }}
                >
                    <img className="image" src={MemberOne} alt="team member" />
                </motion.div>
                <motion.div
                    className="box"
                    ref={ref}
                    variants={boxVariant}
                    initial="hidden"
                    animate={control}
                >
                    <img className="image" src={MemberTwo} alt="team member" />
                </motion.div>
            </div>
        </>
    );
};

export default function App() {
    return (
        <div className="App">
            <Box num={1} />
            <Box num={2} />
            <Box num={3} />
        </div>
    );
}